/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_RenamedInputs */

const zh_sidebar_renamed = /** @type {(inputs: Sidebar_RenamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已重命名`)
};

const en_sidebar_renamed = /** @type {(inputs: Sidebar_RenamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renamed`)
};

const es_sidebar_renamed = /** @type {(inputs: Sidebar_RenamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renombrado`)
};

/**
* | output |
* | --- |
* | "Renamed" |
*
* @param {Sidebar_RenamedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_renamed = /** @type {((inputs?: Sidebar_RenamedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_RenamedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_renamed(inputs)
	if (locale === "en") return en_sidebar_renamed(inputs)
	return es_sidebar_renamed(inputs)
});